import {Component, inject, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular/standalone";

@Component({
  selector: 'app-onetime-popup',
  templateUrl: './onetime-popup.component.html',
  styleUrls: ['./onetime-popup.component.scss'],
  standalone: true
})
export class OnetimePopupComponent  implements OnInit {

  modalController: ModalController = inject(ModalController);
  constructor() { }

  ngOnInit() {}

}
